import { imageUrl } from "@/lib/api";

// Hidden on screen, rendered only when printing (see @media print in index.css).
export default function PrintableManual({ manual }) {
  if (!manual) return null;
  return (
    <div className="print-doc" aria-hidden="true">
      <div className="print-brand">
        Step<span style={{ color: "#5d8a52" }}>My</span>Step — Learn To Do Anything
      </div>
      <h1>{manual.title}</h1>
      <div className="print-meta">
        {manual.estimated_time} · {manual.steps?.length || 0} steps · {manual.difficulty}
      </div>
      {manual.hero_image_id && (
        <img className="print-hero" src={imageUrl(manual.hero_image_id)} alt="" />
      )}

      {manual.supplies?.length > 0 && (
        <section>
          <h2>Required Supplies</h2>
          <ul>{manual.supplies.map((s, i) => <li key={i}>{s}</li>)}</ul>
        </section>
      )}

      {manual.safety_warnings?.length > 0 && (
        <section>
          <h2>Safety Warnings</h2>
          <ul>{manual.safety_warnings.map((s, i) => <li key={i}>{s}</li>)}</ul>
        </section>
      )}

      <section>
        <h2>Steps</h2>
        {manual.steps?.map((st, i) => (
          <div className="print-step" key={i}>
            <h3>{i + 1}. {st.title}</h3>
            {st.why && <p><strong>Why:</strong> {st.why}</p>}
            {st.tip && <p><strong>Tip:</strong> {st.tip}</p>}
          </div>
        ))}
      </section>

      <div className="print-footer">Created with Vittyyo · vittyyo.com</div>
    </div>
  );
}
